export default __webpack_public_path__ + "static/media/mail.8d9ddc92.svg";